module.exports = __webpack_public_path__ + "img/cxample_05.bfe79381.png";